#import "./ContractFields.graphql"

mutation TerminateContract($id: ID!, $terminatedOn: ISO8601Date) {
  terminateContract(input: { id: $id, terminatedOn: $terminatedOn }) {
    contract {
      ...ContractFields
    }
  }
}
